import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { BrandingImageType } from 'ah-api-gateways';
import { useTheme } from 'ah-theme';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLogo',
  setup(__props) {

const theme = useTheme();

const thumbnailLogoLink = computed(() => theme.val?.logos.find((l) => l.type === BrandingImageType.THUMBNAIL)?.link);

return { __sfc: true,theme, thumbnailLogoLink }
}

})